import React, { useEffect, useRef } from 'react'
import { ChildrenReactNode } from '@lib/global'

import { css } from '@emotion/react'
import Footer from './Footer'
import Header from './HeaderVersion2'

const Layout = ({ children }: ChildrenReactNode) => {
  return (
    <div id="layouWrap">
      <Header />
      <main css={mainStyle}>{children}</main>
      <Footer />
    </div>
  )
}
const mainStyle = css`
  overflow: hidden;
`
export default Layout
